import {
  FETCH_TEMPLATE_REQUEST, FETCHING_TEMPLATE_SUCCEEDED, FETCHING_TEMPLATE_FAILED,
  CREATE_STORYBOARD_FROM_TEMPLATE, CREATING_STORYBOARD_FROM_TEMPLATE_SUCCEEDED, CREATING_STORYBOARD_FROM_TEMPLATE_FAILED,
  FETCH_CATEGORIES_AND_INDUSTRIES_REQUEST, FETCHING_CATEGORIES_AND_INDUSTRIES_SUCCEEDED, FETCHING_CATEGORIES_AND_INDUSTRIES_FAILED,
  CREATE_TEMPLATE_REQUEST, CREATING_TEMPLATE_SUCCEEDED,CREATING_TEMPLATE_FAILED,
  UPDATE_TEMPLATE_REQUEST,UPDATING_TEMPLATE_SUCCEEDED,UPDATING_TEMPLATE_FAILED,
  DELETE_TEMPLATE_REQUEST,DELETING_TEMPLATE_SUCCEEDED,DELETING_TEMPLATE_FAILED,
  UPDATE_TEMPLATE_VISIBILITY_REQUEST, UPDATING_TEMPLATE_VISIBILITY_SUCCEEDED, UPDATING_TEMPLATE_VISIBILITY_FAILED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const TEMPLATES_URL = `${apiUrl}/api/2.0/templates`;


/**
 * Fetch templates
*/
export const fetchTemplates = createAction(FETCH_TEMPLATE_REQUEST, (page, limit, request) => {
  return {
    page: page,
    limit: limit,
    request: request
  };
});

const fetchingTemplatesSucceeded = createAction(FETCHING_TEMPLATE_SUCCEEDED, (response) => {
  return response
});

const fetchingTemplatesFailed = createAction(FETCHING_TEMPLATE_FAILED, (error) => {
  return error;
});

function* fetchTemplatesSaga(action) {
  const {page, limit, request} = action.payload;
  
  const queryParams = {
    page: page,
    limit: limit
  }

  let url = buildUrl(TEMPLATES_URL, {
    queryParams: queryParams
  });

  const fetchTemplatesAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchTemplatesAPI);
    yield put(fetchingTemplatesSucceeded(response));
  } catch (error) {
    yield put(fetchingTemplatesFailed(error));
  }
}

/**
 * Create storyboard from template
*/
export const createStoryboardFromTemplate = createAction(CREATE_STORYBOARD_FROM_TEMPLATE, (name, template) => {
  return {
    name: name,
    template: template
  };
});

const creatingStoryboardFromTemplateSucceeded = createAction(CREATING_STORYBOARD_FROM_TEMPLATE_SUCCEEDED, (response) => {
  return response
});

const creatingStoryboardFromTemplateFailed = createAction(CREATING_STORYBOARD_FROM_TEMPLATE_FAILED, (error) => {
  return error;
});


function* createStoryboardFromTemplateSaga(action) {
  
}

/**
 * Fetch Categories and Industries
 */

export const fetchCatgeoriesAndIndustries = createAction(FETCH_CATEGORIES_AND_INDUSTRIES_REQUEST);

const fetchingCatgeoriesAndIndustriesSucceeded = createAction(FETCHING_CATEGORIES_AND_INDUSTRIES_SUCCEEDED, (response) => {
  return response
});

const fetchingCatgeoriesAndIndustriesFailed = createAction(FETCHING_CATEGORIES_AND_INDUSTRIES_FAILED, (error) => {
  return error;
});

function* fetchingCatgeoriesAndIndustriesSaga(action) {

  const url = `${TEMPLATES_URL}/categories-industries`;
  const fetchCatgeoriesAndIndustriesAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchCatgeoriesAndIndustriesAPI);
    yield put(fetchingCatgeoriesAndIndustriesSucceeded(response));
  } catch (error) {
    yield put(fetchingCatgeoriesAndIndustriesFailed(error));
  }
}

/**
 * Create template from Storyboard
 */

export const createTemplate = createAction(CREATE_TEMPLATE_REQUEST, (request) => {
  return {
    request: request
  };
});

const creatingTemplateSucceeded = createAction(CREATING_TEMPLATE_SUCCEEDED, (response) => {
  return response
});

const creatingTemplateFailed = createAction(CREATING_TEMPLATE_FAILED, (error) => {
  return error;
});

function* createTemplateSaga(action) {
  const {request} = action.payload;

  const url = `${TEMPLATES_URL}/create`;

  const createTemplateAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createTemplateAPI);
    yield put(creatingTemplateSucceeded(response));
  } catch (error) {
    yield put(creatingTemplateFailed(error));
  }
}

/**
 * Update template from Storyboard
 */

export const updateTemplate = createAction(UPDATE_TEMPLATE_REQUEST, (request) => {
  return {
    request: request
  };
});

const updatingTemplateSucceeded = createAction(UPDATING_TEMPLATE_SUCCEEDED, (response) => {
  return response
});

const updatingTemplateFailed = createAction(UPDATING_TEMPLATE_FAILED, (error) => {
  return error;
});

function* updateTemplateSaga(action) {
  const {request} = action.payload;

  const url = `${TEMPLATES_URL}`;

  const updateTemplateAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateTemplateAPI);
    yield put(updatingTemplateSucceeded(response));

    let request = {
      type: "", category: "", industry: "", sort: "created_date", order: "DESC", superAdmin: true
    }
    yield put(fetchTemplates(0, 20, request ))
  } catch (error) {
    yield put(updatingTemplateFailed(error));
  }
}

/**
 * Delete template
 */

export const deleteTemplate = createAction(DELETE_TEMPLATE_REQUEST, (id) => {
  return {
    id: id
  };
});

const deletingTemplateSucceeded = createAction(DELETING_TEMPLATE_SUCCEEDED, (response) => {
  return response
});

const deletingTemplateFailed = createAction(DELETING_TEMPLATE_FAILED, (error) => {
  return error;
});

function* deleteTemplateSaga(action) {
  const {id} = action.payload;

  const url = `${TEMPLATES_URL}/${id}`;

  const deleteTemplateAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteTemplateAPI);
    yield put(deletingTemplateSucceeded(response));
    let request = {
      type: "", category: "", industry: "", sort: "created_date", order: "DESC", superAdmin: true
    }
    yield put(fetchTemplates(0, 20, request ))
  } catch (error) {
    yield put(deletingTemplateFailed(error));
  }
}

/**
 * Enable/Disable template
 */

export const updateTemplateVisibility = createAction(UPDATE_TEMPLATE_VISIBILITY_REQUEST, (id, enabled) => {
  return {
    id: id,
    enabled: enabled
  };
});

const updatingTemplateVisibilitySucceeded = createAction(UPDATING_TEMPLATE_VISIBILITY_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
});

const updatingTemplateVisibilityFailed = createAction(UPDATING_TEMPLATE_VISIBILITY_FAILED, (id, error) => {
  return {
    id: id,
    response: error
  };
});

function* updateTemplateVisibilitySaga(action) {
  const {id, enabled} = action.payload;

  const url = `${TEMPLATES_URL}/visibility`;

  const request = {
    template: id,
    enabled: enabled
  }

  const updateTemplateVisibilityAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateTemplateVisibilityAPI);
    yield put(updatingTemplateVisibilitySucceeded(id, response));
  } catch (error) {
    yield put(updatingTemplateVisibilityFailed(id, error));
  }
}

export default function* templateSaga() {
  yield takeEvery(FETCH_TEMPLATE_REQUEST, fetchTemplatesSaga);
  yield takeEvery(FETCH_CATEGORIES_AND_INDUSTRIES_REQUEST, fetchingCatgeoriesAndIndustriesSaga);
  yield takeEvery(CREATE_TEMPLATE_REQUEST, createTemplateSaga);
  yield takeEvery(UPDATE_TEMPLATE_REQUEST, updateTemplateSaga);
  yield takeEvery(DELETE_TEMPLATE_REQUEST, deleteTemplateSaga);
  yield takeEvery(UPDATE_TEMPLATE_VISIBILITY_REQUEST, updateTemplateVisibilitySaga);
}